import React, { useEffect, useState } from "react";
import "./Style.css";
import Chart from "chart.js/auto";
import annotationPlugin from 'chartjs-plugin-annotation'
import {
  // Chart,
  CategoryScale,
  LinearScale,
  Filler,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";

Chart.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
  annotationPlugin
);

const numberOfColmns = 10;
function getFormattedDate() {
  const today = new Date();
  const month = (today.getMonth() + 1).toString().padStart(2, '0'); // getMonth() is zero-based
  const day = today.getDate().toString().padStart(2, '0');
  return `${month}/${day}`;
}

const maxValuePerUnit = {
  "WPM": 500,
  "LPM": 100,
  "CM": 55
}


function toInteger(str) {
  // Remove commas, convert to number, and floor to remove decimals
  return Math.floor(parseFloat(str.replace(/,/g, '')));
}

export default function Graph({ data: dataArr, moreData: { STDArr: stdYValues, CMPArr: cmpYValues }, tabUnit, labs }) {
  const [labels, setLabels] = useState([]);
  const [lllabl, setLllabl] = useState([]);
  const [first, setFirst] = useState([]);
  const [second, setSecond] = useState([]);
  const [third, setThird] = useState([]);
  const [maxValue, setMaxValue] = useState(maxValuePerUnit[tabUnit]);
  const [mainChosenColor, setMainChosenColor] = useState("")
  const [secondaryChosenColor, setSecondaryChosenColor] = useState("");
  let mainOrange = "#f39c12";
  let mainPurple = "#7D56A5";
  let mainBlue = "#35BFEA";
  let secondaryOrange = "#f39c12b5";
  let secondaryPurple = "#9c8cbf";
  let secondaryBlue = "#A1D9F0";

  // const annotations = tabUnit == "WPM" ? annotationsBuilder(dataArr, [25, 15, 10]) : null;

  useEffect(() => {
    setMainChosenColor(tabUnit == "WPM" ? mainOrange : tabUnit == "LPM" ? mainPurple : mainBlue);
    setSecondaryChosenColor(tabUnit == "WPM" ? secondaryOrange : tabUnit == "LPM" ? secondaryPurple : secondaryBlue)
    setMaxValue(maxValuePerUnit[tabUnit]);
  }, [tabUnit])

  useEffect(() => {
    let arr = labs.map(value => {
      const parts = value.split('/');
      let result
      if (parts.length >= 2) {
        result = parts[0] + '/' + parts[1];
      }
      return result
    });
    setLabels(arr);
  }, [labs])



  const options = {
    // maintainAspectRatio: false,
    events: ["click", "mouseout", "touchend"],
    scales: {

      'x-axis-bar': {
        type: 'category',
        offset: true, // Ensures bars remain centered on their labels
        display: false,
        position: 'bottom'
      },
      'x-axis-line': {
        type: 'category',
        offset: false, // Ensures the line dataset starts at the left wall
        display: false,
        position: 'bottom'
      },
      'x-axis-line2': {
        type: 'category',
        offset: false, // Ensures the line dataset starts at the left wall
        display: false,
        position: 'bottom'
      },
      x: {
        // <-- axis is not array anymore, unlike before in v2.x: '[{'
        id: 'x-axis-0',
        offset: false,
        grid: {
          // offset: false,
          borderColor: mainChosenColor, // <-- this line is answer to initial question
          borderWidth: 2,
          display: false,
        },
        ticks: {
          align: 'start'
        },
        // max: getFormattedDate()
      },
      y: {
        // <-- axis is not array anymore, unlike before in v2.x: '[{'
        id: 'y-axis-0',
        grid: {
          // color: "rgba(0,255,0,0.1)",
          borderColor: mainChosenColor, // <-- this line is answer to initial question
          display: false,
          borderWidth: 2,
        },
        // beginAtZero: true,
        min: tabUnit === "CM" ? 3 : 0,
        max: maxValue,
        ticks: {
          // steps: tabUnit === "CM" ? 5 : null,
          display: tabUnit !== "WPM",
          stepSize: tabUnit === "CM" ? 5 : null
        },
        reverse: tabUnit === "CM",
      },
    },
    responsive: true,
    tension: 0.1,
    showLine: true,
    interaction: {
      intersect: false,
      mode: 'index',
    },
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {

        // displayDuration: 200, // זמן במילישניות

        //fonts of the hover box
        titleFont: {
          family: "commic-sans-ms",
        },
        bodyFont: {
          weight: "bold",
        },
        bodyColor: mainChosenColor,
        titleColor: "white",
        titleAlign: "center",
        footerSpacing: 7,
        displayColors: false,
        bodyAlign: "center",
        callbacks: {
          // footer: (tooltipItems) => {
          //   console.log("🚀 ~ tooltipItems:", tooltipItems)
          //   let sum = 0;

          //   tooltipItems.forEach(function (tooltipItem) {
          //     sum += tooltipItem.parsed.y;
          //   });
          //   return 'Sum: ' + sum;
          // },
          labelTextColor: function (context) {
            if (tabUnit == "WPM") {

              switch (context.datasetIndex) {
                case 0:
                  return "#01fe1a"

                  break;
                case 1:
                  return mainChosenColor

                  break;
                case 2:
                  return "#dc3545"

                default:
                  return mainOrange
                  break;
              }
            }
          },
          label: function (context) {
            let formattedValue = toInteger(context?.formattedValue);
            if (formattedValue) {

              if (tabUnit == "WPM") {

                switch (context.datasetIndex) {
                  case 0:
                    formattedValue = `${Math.abs(formattedValue - (400)).toFixed(0)}  SD`;

                    break;
                  case 1:
                    formattedValue = formattedValue.toFixed(0) + ` ${tabUnit}`;
                    break;
                  case 2:
                    formattedValue = `${((formattedValue / maxValue) * 100).toFixed(0)}%  CMP`;

                  default:
                    break;
                }
              } else {

                formattedValue += ` ${tabUnit}`;
              }
            }
            return formattedValue;
          },
        },


      },
      annotation: {
        // annotations: annotations
      },


    },
  }

  //labs = labels = Xvalues
  //data = Yvalues

  //Purple =

  useEffect(() => {
    let lllablArr = [], firstArr = [], secondArr = [], thirdArr = [];
    let maximum = maxValue;
    const dataSet = dataArr.map((v, i) => {
      if (v && tabUnit == "WPM") {
        lllablArr.push(labels[i]);
        firstArr.push(stdYValues[i]);
        secondArr.push(dataArr[i]);
        thirdArr.push(cmpYValues[i]);
        if (v > maximum) {
          maximum = Math.round(v);
        }
        return v
      } else {
        if (tabUnit !== "WPM") {

          lllablArr.push(labels[i]);
          firstArr.push(stdYValues[i]);
          secondArr.push(dataArr[i]);
          thirdArr.push(cmpYValues[i]);
          if (v > maximum) {
            maximum = Math.round(v);
          }

        }
        return v
      }
    })
    setMaxValue(maximum)
    setLllabl(lllablArr);
    setFirst(firstArr);
    setSecond(secondArr);
    setThird(thirdArr);

  }, [labels])

  const avg = calculateAverage(dataArr)
  const [data, setData] = useState(null)


  useEffect(() => {
    let dataSet;
    if (tabUnit == "WPM") {
      dataSet = {
        labels: lllabl,
        datasets: [

          {
            xAxisID: 'x-axis-line2',
            data: tabUnit == "WPM" ? first.map((v, i) => 400 - v) : [],
            borderColor: "#01fe1a66",
            borderWidth: 5,
            pointBorderWidth: 1,
            backgroundColor: "#00000073",
            fill: false,
            pointHoverBorderColor: "#00000073",
            pointHoverBackgroundColor: "white",
            pointHoverBorderWidth: 3,
            pointRadius: 1,
            hitRadius: 1,
            hoverRadius: 1,
            tooltipBackgroundColor: "red",
            spanGaps: true,
            showLine: true,
          },
          {

            xAxisID: 'x-axis-line',
            data: second,
            borderColor: mainChosenColor,
            borderWidth: 0.85,
            pointBorderWidth: 1,
            backgroundColor: secondaryChosenColor,

            fill: {
              target: "start",

              // below: secondaryChosenColor, 
            },
            pointHoverBorderColor: mainChosenColor,
            pointHoverBackgroundColor: "white",
            pointHoverBorderWidth: 3,
            pointRadius: 1,
            hitRadius: 1,
            hoverRadius: 1,
            tooltipBackgroundColor: "red",
            spanGaps: true,
          },
          {
            xAxisID: 'x-axis-bar',
            index: 0,
            type: third[0] ? "bar" : "line",
            tooltip: "ccccc",
            data: third[0] ? third.map((v, i) => v ? (v * (maxValue / 10)) : null) : [],
            borderColor: "#dc3545",
            borderWidth: 200,
            barThickness: third[0] ? 200 / third.length : 20,
            pointBorderWidth: 4,
            backgroundColor: "#dc3545",
            fill: false,
            pointHoverBorderColor: mainPurple,
            pointHoverBackgroundColor: "white",
            pointHoverBorderWidth: 6.5,
            pointRadius: 1,
            hitRadius: 3,
            hoverRadius: 6,
            tooltipBackgroundColor: "red",
            spanGaps: true,
            showLine: true,
          },
        ],
      }
    } else {
      dataSet = {
        labels: lllabl,
        datasets: [
          {

            xAxisID: 'x-axis-line',
            data: second,
            borderColor: mainChosenColor,
            borderWidth: 0.85,
            pointBorderWidth: 1,
            backgroundColor: secondaryChosenColor,

            fill: {
              target: "start",

            },
            pointHoverBorderColor: mainChosenColor,
            pointHoverBackgroundColor: "white",
            pointHoverBorderWidth: 3,
            pointRadius: 1,
            hitRadius: 1,
            hoverRadius: 1,
            tooltipBackgroundColor: "red",
            spanGaps: true,
          },
        ],
      }
    }
    setData(dataSet);

  }, [third])

  return data ? <Line options={options} data={data} /> : <></>;

}
const chartData = {
  labels: ["08/20/23", "08/21/23"],
  datasets: [
    {
      data: [94, 138],
      borderColor: "#f39c12",
      borderWidth: 0.85,
      pointBorderWidth: 4,
      backgroundColor: "white",
      fill: {
        target: "origin",
        above: "rgb(243, 156, 35, 0.3)",
      },
      pointHoverBorderColor: "#7D56A5",
      pointHoverBackgroundColor: "white",
      pointHoverBorderWidth: 6.5,
      pointRadius: 5,
      hitRadius: 3,
      hoverRadius: 6,
      tooltipBackgroundColor: "red",
      spanGaps: true,
    },
    // Add a new dataset for the standard deviation
    {
      label: "Standard Deviation",
      data: [
        { x: 0, y: 94 + 16.4 }, // Upper bound for the first point
        { x: 1, y: 138 + 34.4 }, // Upper bound for the second point
        { x: 1, y: 138 - 34.4 }, // Lower bound for the second point
        { x: 0, y: 94 - 16.4 }, // Lower bound for the first point
      ],
      fill: true,
      backgroundColor: "rgba(100, 100, 100, 0.2)",
    },
  ],
};
// function annotationsBuilder(dataArray, arrayOfSTD) {
//   let anotiations = {}
//   dataArray.map((value, i) => {
//     let anotationTop = {
//       type: 'line',
//       borderColor: 'green',
//       borderWidth: 20,
//       label: {
//         display: true,
//         backgroundColor: 'green',
//         borderRadius: 0,
//         color: 'white',
//         content: 40
//       },
//       xMax: i + 30 + 0.05,
//       xMin: i + 200 - 0.05,
//       xScaleID: 'x',
//       yMax: value + arrayOfSTD[i],
//       yMin: value + arrayOfSTD[i],
//       yScaleID: 'y'
//     };
//     let anotationBottom = {
//       type: 'line',
//       borderColor: 'green',
//       borderWidth: 20,
//       label: {
//         display: true,
//         backgroundColor: 'green',
//         borderRadius: 0,
//         color: 'white',
//         content: 40
//       },
//       xMax: i + 5 + 0.05,
//       xMin: i + 5 - 0.05,
//       xScaleID: 'x',
//       yMax: value - arrayOfSTD[i],
//       yMin: value - arrayOfSTD[i],
//       yScaleID: 'y'
//     };
//     anotiations[`top${i}`] = anotationTop
//     anotiations[`bottom${i}`] = anotationBottom

//   })
//   return anotiations

// }
function annotationsBuilder(dataArray, arrayOfSTD) {
  let annotations = {}
  let counterForRealIndex = 0
  dataArray.map((value, i) => {
    if (!value) return;
    // let annotationTop = {
    //   type: 'line',
    //   borderColor: 'green',
    //   borderWidth: 1,
    //   label: {
    //     enabled: true,
    //     backgroundColor: 'green',
    //     borderRadius: 0,
    //     fontColor: 'white',
    //     content: '40', // You can replace this with a function or variable if needed
    //   },
    //   xMax: i + 30 + 0.05,
    //   xMin: i + 200 - 0.05,
    //   // xScaleID: 'x-axis-0', // Replace with your x-axis scale ID
    //   yMax: value + arrayOfSTD[i],
    //   yMin: value + arrayOfSTD[i],
    //   // yScaleID: 'y-axis-0', // Replace with your y-axis scale ID
    // };
    let annotationTop = {
      // Indicates the type of annotation
      type: "line",
      xMin: i - 0.5,
      xMax: i + 0.5,
      yMin: value + arrayOfSTD[counterForRealIndex],
      yMax: value + arrayOfSTD[counterForRealIndex],
      backgroundColor: "rgba(255, 99, 132, 0.25)"
    }
    let annotationBottom = {
      type: 'line',
      // borderColor: 'green',
      // borderWidth: 1,
      // label: {
      //   enabled: false,
      //   backgroundColor: 'green',
      //   borderRadius: 0,
      //   fontColor: 'white',
      //   content: '40', // You can replace this with a function or variable if needed
      // },
      xMin: i - 0.5,
      xMax: i + 0.5,
      yMin: value - arrayOfSTD[counterForRealIndex],
      yMax: value - arrayOfSTD[counterForRealIndex],
      // xMax: i + 5 + 0.05,
      // xMin: i + 5 - 0.05,
      // xScaleID: 'x-axis-0', // Replace with your x-axis scale ID
      // yMax: value - arrayOfSTD[i],
      // yMin: value - arrayOfSTD[i],
      // yScaleID: 'y-axis-0', // Replace with your y-axis scale ID
      backgroundColor: "rgba(255, 99, 132, 0.25)"
    };
    annotations[`top${i}`] = annotationTop
    annotations[`bottom${i}`] = annotationBottom
    counterForRealIndex++
  })

  return annotations;
}

function calculateAverage(arr) {
  const filteredArray = arr.filter(item => item !== null); // Remove null values
  const sum = filteredArray.reduce((acc, value) => acc + value, 0); // Sum non-null values
  const average = sum / filteredArray.length; // Divide by the number of non-null values
  return average;
}
